/**************************************************
 * Nombre:       Tarjeta_Tienda
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {NearMe} from '@mui/icons-material'
import {irUrl} from "../../Utilidades/irUrl";

const Tarjeta_Tienda = ({item, derecha}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            direction={!derecha ? 'row' : 'row-reverse'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                borderRadius: 4,
                background: 'rgba(255, 255, 255, 0.20)',
                backdropFilter: 'blur(5px)',

                color: '#fff'
            }}
        >

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 6, sm: 6, md: 6}}
                sx={{
                    p: 2,
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: derecha ? 'flex-end' : 'flex-start', mt: -0.5}}>
                    <Typography sx={{textAlign: derecha ? 'right' : 'left', height: 56}}>{item.direccion}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: derecha ? 'flex-end' : 'flex-start', mt: 0, mb: -0.5}}>
                    <Button
                        onClick={() => irUrl(item.url)}
                        startIcon={<NearMe/>}
                        sx={{
                            py: 1,
                            px: 3,
                            borderRadius: 8,
                            background: 'rgba(255, 255, 255, 0.20)',
                            color: '#fff',
                            maxHeight: 40,
                            fontSize: 14
                        }}
                    >
                        DIRIGEME
                    </Button>
                </Grid>


            </Grid>

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>

                <img src={item.img} width={'100%'} height={'auto'} alt={item.titulo}
                     style={{
                         borderRadius: 10,
                         boxShadow: '0 1px 8px 0 rgba(255, 255, 255, 0.25)',
                         backdropFilter: 'blur(5px)'
                     }}/>

            </Grid>

        </Grid>
    )

}
export default Tarjeta_Tienda